import React, { useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Client } from "../../../interfaces/ClientInterface";
import TrainingCard from "./TrainingCard";
import TrainingCreateEdit from "./TrainingCreateEdit";
import { useTraining } from "../../../hooks/query/useTraining";

interface TrainingsProps {
  clientData: Client;
}

const Trainings: React.FC<TrainingsProps> = ({ clientData }) => {
  const [openCreate, setOpenCreate] = useState(false);

  // query
  const { data: trainings = [], isLoading, refetch } = useTraining(clientData.id);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100%"
      }}
    >
      <Box
        sx={{
          p: 1.25,
          display: "flex",
          justifyContent: "flex-end",
          borderBottom: 1,
          borderColor: "divider"
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => setOpenCreate(true)}
          data-testmation="addTrainingButton"
        >
          Add Training
        </Button>
      </Box>

      {trainings.length === 0 ? (
        <Box
          sx={{
            py: 6,
            p: 2,
            textAlign: "center",
            flex: 1
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "text.secondary" }}>
            No trainings or certificates available
          </Typography>
          <Typography variant="body2" sx={{ color: "text.disabled", mt: 0.5 }}>
            This client does not have any recorded training or certificate details yet.
          </Typography>
        </Box>
      ) : (
        <Box sx={{ p: 2, flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          {trainings.map((training, index) => (
            <TrainingCard
              // eslint-disable-next-line react/no-array-index-key
              key={training.id || index}
              training={training}
              client={clientData}
              onRefresh={refetch}
            />
          ))}
        </Box>
      )}

      {openCreate && (
        <TrainingCreateEdit
          clientId={clientData.id}
          onClose={() => setOpenCreate(false)}
          afterSave={() => {
            setOpenCreate(false);
            refetch();
          }}
        />
      )}
    </Box>
  );
};

export default Trainings;
